"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logo = exports.item = exports.appbar = void 0;

var _react = require("@emotion/react");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  height: 28px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid #d3d4df;\n  box-shadow: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var appbar = (0, _react.css)(_templateObject());
exports.appbar = appbar;
var item = (0, _react.css)(_templateObject2());
exports.item = item;
var logo = (0, _react.css)(_templateObject3(), item);
exports.logo = logo;